/* @ngInject */
function onboardingDialogService ($q, $translate, UdsModalService) {
  const getOnboardingDialogController = () => $q.when(import('../dialogs/onboarding-dialog/onboarding-dialog.controller'))

  const service = {
    openDialog,
    getChecklistDescription,
    getCampaignsDescription
  }
  return service

  function openDialog (data) {
    getOnboardingDialogController().then(({ OnboardingDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: OnboardingDialogController,
        modalName: 'onboardingDialog',
        data
      })
      modal.open()
    })
  }

  function getChecklistDescription () {
    const firstLine = $translate.instant('onboardingDialogChecklist.description.firstLine')
    const secondLine = $translate.instant('onboardingDialogChecklist.description.secondLine')
    const lastLine = $translate.instant('onboardingDialogChecklist.description.lastLine')
    const listFirstItem = $translate.instant('onboardingDialogChecklist.list.firstItem')
    const listSecondItem = $translate.instant('onboardingDialogChecklist.list.secondItem')
    const listThirdItem = $translate.instant('onboardingDialogChecklist.list.thirdItem')

    return `<uds-body size="md" font-weight="regular">${firstLine}<uds-title size="sm" font-weight="bold">${secondLine}</uds-title>${lastLine}<ul><li>${listFirstItem}</li><li>${listSecondItem}</li><li>${listThirdItem}</li></ul></uds-body>`
  }

  function getCampaignsDescription () {
    const firstLine = $translate.instant('onboardingDialogCampaigns.description.firstLine')
    const secondLine = $translate.instant('onboardingDialogCampaigns.description.secondLine')
    const lastLine = $translate.instant('onboardingDialogCampaigns.description.lastLine')
    const listFirstItem = $translate.instant('onboardingDialogCampaigns.list.firstItem')
    const listSecondItem = $translate.instant('onboardingDialogCampaigns.list.secondItem')

    return `<uds-body size="md" font-weight="regular">${firstLine}<uds-title size="sm" font-weight="bold">${secondLine}</uds-title>${lastLine}<ul><li>${listFirstItem}</li><li>${listSecondItem}</li></ul></uds-body>`
  }
}

export { onboardingDialogService }
